import {GET_QUESTIONS_START} from "../../types";

export const questions = (payload) => ({
  type: GET_QUESTIONS_START,
  payload,
});
